<template>
  <v-layout justify-center v-if="getAccountStatus">
    <v-flex xs12 sm8 md6 xl4 class="mt-4">
      <v-sheet class="text-center pa-5 c-sheet">
        <img class="w-75 ma-3" src="../assets/premium.png">
        <p>
          This section is restricted to premium users only.
          <br>Become a premium user today.
          <br>
          <span class="lr--text font-weight-medium ib mt-2">Contact +91 9811428849</span>
        </p>
      </v-sheet>
    </v-flex>
  </v-layout>
  <v-layout v-else column>
    <v-layout v-if="!isOlympiadsFetched" column justify-center align-center class="mt-5">
      <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
      <p class="subheading-1 mt-5 primary--text font-weight-bold">Downloading Olympiads...</p>
    </v-layout>
    <div v-else>
      <h3 class="font-weight-medium mb-4">Olympiads</h3>

      <v-layout v-if="!getOlympiads.length">No Olympiads available for your grade at the moment.</v-layout>
      <v-layout v-else wrap>
        <v-flex
          md4
          lg4
          xl3
          v-for="olympiad in getOlympiads"
          :key="olympiad.olympiadId"
          class="mb-5 prsCard"
        >
          <v-card
            class="pcard white--text"
            :class="[(hoursLeft(olympiad.availableTill) < 0 || olympiad.completed) && !olympiad.finished ? 'completed' : '', olympiad.finished ? 'finished' : '']"
            @click="hoursLeft(olympiad.availableTill) < 0 || olympiad.completed  ?  olympiad.finished ? $router.push('/olympiad/view/'+olympiad.olympiadId) : ''  : $router.push('/olympiads/'+olympiad.olympiadId)"
          >
            <v-chip class="caption premium-tag" v-if="!olympiad.finished">
              <v-icon small class="mr-1">mdi-calendar-clock</v-icon>
              {{ hoursLeft(olympiad.availableTill) > 0 ? `${hoursLeft(olympiad.availableTill)} Hours Left` : 'Under Review'}}
            </v-chip>
            <v-card-actions class="body-2 font-weight-regular">
              <v-layout column>
                <v-flex>{{olympiad.olympiadTitle}}</v-flex>
                <div v-if="olympiad.completed && !olympiad.finished">
                  <v-flex>[Submitted]</v-flex>
                </div>
                <div v-if="olympiad.finished">
                  <v-flex>[Result Out!]</v-flex>
                </div>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </v-layout>
</template>

<script>
import differenceInHours from "date-fns/difference_in_hours/index";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      olympiads: []
    };
  },
  computed: {
    ...mapGetters(["getAccountStatus", "getOlympiads", "isOlympiadsFetched"])
  },
  methods: {
    ...mapActions(["fetchOlympiads"]),
    hoursLeft(date) {
      return differenceInHours(date.toDate(), new Date());
    }
  },
  created() {
    if (!this.getAccountStatus && !this.isOlympiadsFetched) {
      this.olympiads = this.fetchOlympiads();
    }
  }
};
</script>

<style>
.w-75 {
  width: 75px;
}

.ib {
  display: inline-block;
}

.c-sheet {
  border-radius: 8px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
}

.finished {
  animation: scaling 1s infinite;
}

@keyframes scaling {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
</style>